import React from 'react';

const Home = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      d="M19.962,8.7l0,0L11.8.539a1.841,1.841,0,0,0-2.6,0L1.042,8.693,1.034,8.7a1.84,1.84,0,0,0,1.225,3.137l.057,0h.325v6A2.158,2.158,0,0,0,4.8,20H7.989a.586.586,0,0,0,.586-.586V14.707a.984.984,0,0,1,.983-.983h1.883a.984.984,0,0,1,.983.983v4.707A.586.586,0,0,0,13.01,20H16.2a2.157,2.157,0,0,0,2.155-2.155v-6h.3a1.842,1.842,0,0,0,1.3-3.142Zm-.83,1.774a.665.665,0,0,1-.473.2h-.888a.586.586,0,0,0-.586.586v6.59a.984.984,0,0,1-.983.983H13.6V14.707a2.158,2.158,0,0,0-2.155-2.155H9.558A2.158,2.158,0,0,0,7.4,14.707v4.121H4.8a.984.984,0,0,1-.983-.983v-6.59a.586.586,0,0,0-.586-.586h-.9a.669.669,0,0,1-.461-1.142h0l8.159-8.158a.669.669,0,0,1,.946,0L19.13,9.524l0,0A.671.671,0,0,1,19.133,10.473Zm0,0"
      transform="translate(-0.5)"
    />
  </svg>
);

export default Home;
